// Lodash
import { get } from 'lodash';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { EmployeeState, initialState } from './state';


/**
 * This effect is for listen Employee actions, execute auth service call and dispatch in Employee reducer.
 * For Employee api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 24/4/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created Employee effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): EmployeeState {
  switch (action.type) {
    // Employee COMMON METHOD
    case ActionTypes.EMPLOYEE_COMMON: {
      return state;
    }
    // Employee Success COMMON METHOD
    case ActionTypes.EMPLOYEE_COMMON_SUCCESS: {
      // commonly store and handle all Employee modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }
    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
